export interface RecordExpensePreferences {
  addAnother: boolean;
}

const DEFAULT_PREFERENCES: RecordExpensePreferences = {
  addAnother: false,
};

function getPreferencesStorageKey(churchId?: string) {
  return churchId
    ? `spending-record-expense-preferences:${churchId}`
    : 'spending-record-expense-preferences';
}

export function loadRecordExpensePreferences(churchId?: string): RecordExpensePreferences {
  if (typeof window === 'undefined') {
    return DEFAULT_PREFERENCES;
  }

  try {
    const raw = window.localStorage.getItem(getPreferencesStorageKey(churchId));
    if (!raw) {
      return DEFAULT_PREFERENCES;
    }

    const parsed = JSON.parse(raw) as Partial<RecordExpensePreferences>;
    return {
      addAnother: parsed.addAnother === true,
    };
  } catch {
    return DEFAULT_PREFERENCES;
  }
}

export function persistRecordExpensePreferences(
  churchId: string | undefined,
  preferences: RecordExpensePreferences,
) {
  if (typeof window === 'undefined') {
    return;
  }

  try {
    window.localStorage.setItem(getPreferencesStorageKey(churchId), JSON.stringify(preferences));
  } catch {
    // Ignore storage failures and fall back to the in-memory state for this session.
  }
}
